import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { TermsAndConditionsDialogComponent } from '../terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { clearLocalStorage, getILCookie, setILCookie, setLoggedInUserData, getIpAddress, isUserAdmin } from 'src/app/helpers/functions';
import { AuthService } from '@app-services/auth-service/auth.service';
import { Location } from '@angular/common';
import { environment } from '@app-environments/environment';
import { LoginService } from '@app-services/login/login.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import {BoardsService} from '@app-services/boarrds/boards.service';
import {festivalSyllabus} from '@app-services/IL-syllabus/festival-syllabus';
import {states} from '@subscription-constants/subscriptionconstant';
import * as moment from 'moment';
import {NgxSpinnerService} from 'ngx-spinner';
import {apisDataCacheKeys} from '@app-constants/app.constants';
import {FestivalPaymentComponent} from '../festival-payment/festival-payment.component';
import {TestRegistrationConfirmDialogComponent} from '../test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import {ilstates} from '@app-services/IL-syllabus/il-states-data';
import {HttpUrlEncodingCodec} from '@angular/common/http';
import { element } from 'protractor';
import { FirebaseService } from '@app-services/firebase/firebase.service';
declare let $: any;

@Component({
  selector: 'app-festival-offer',
  templateUrl: './festival-offer.component.html',
  styleUrls: ['./festival-offer.component.scss']
})
export class FestivalOfferComponent implements OnInit {
  enrollnowForm!: FormGroup;
  otpSent: boolean = false;
  otp: any;
  time: number = 0;
  restime: number = 0;
  resendotp: boolean = false;
  counter;
  otpValid: boolean = false;
  otpError: boolean = false;
  isOtpVerified = false;
  userId: any;
  userData: any;
  queryParams: any;
  navExtra;
  packageDeatails: any = [];
  examName:any;
  grades:any;
  updatedUser:any;
  filterdPackage:any;
  festivalSyllabus = festivalSyllabus;
  filterData:any;
  gradeData:any;
  selectedSubject;
  exams = {
    'JEE': 'JEEMAIN',
    'NEET': 'NEET',
    'CBSE': 'CBSE'
  };
  selectedGrade:any;

  subscriptionbillingUtility: any = {
    selectedPackage: {},
    selectedBatch: {},
    selectedDuration: [],
    userDetails: {},
    today: new Date(),
    stateName: '',
    discountAmount: 0,
    states: states,
    selectedDateAndTime: {},
    localUserData:{},
    courseSelected:{},
    subscriptionPacakgeIdList: [],
    packageSubscriptionAmountList: [],
    discountCodecoupounPer: 0,
    emiPayLaterFulltotalAmount:0,
    discountPercentage:0
  };

  selectedBatch: any;
  courseSelected: any;
  ilstates = ilstates;
  sharedLink:any;
  linkCopid:boolean = false;
  public copy: any;
  encode = new HttpUrlEncodingCodec;
  encodedUrl:any;
  microCourses:boolean = false;
  selectedMonths:any;
  microMobAmount:any;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;
  isExitingUser:boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public singupService: SignupService,
    private userService: UserService,
    private gaService: GAnalyticsService,
    private authService: AuthService,
    private location: Location,
    private loginService: LoginService,
    private SubscriptionService: SubscriptionService,
    private targetExamService: BoardsService,
    public spinner: NgxSpinnerService,
    private firebaseService: FirebaseService
  ) {
    this.navExtra = this.router.getCurrentNavigation()?.extras?.state;
    let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
    this.queryParams = { ..._params };
    console.log(this.queryParams);
   
    let token = localStorage.getItem('token');
    if(token){
      clearLocalStorage();
      window.location.reload();
      return;
    }
    

  }

  ngOnInit(): void {
  if(this.queryParams?.microCourses ==='micro'){
    this.microCourses = true;
    this.selectedMonths = this.queryParams?.numOfMonths;
    var param1 = {
      examName: this.queryParams?.examName,
      year: this.queryParams?.year,
      producttype: this.queryParams?.productType,
      grade: this.queryParams?.grade,
      pageUrl: this.queryParams?.pageUrl,
    }
    console.log(param1);
    console.log(this.queryParams?.productName);
    let grade = this.queryParams.grade;
    this.selectedGrade = grade;
    localStorage.setItem('grade', this.queryParams.grade);
    this.SubscriptionService.getPackageDetails(param1, grade).subscribe((result: any) => {
      this.packageDeatails = result.find(element=> element.id == this.queryParams?.id);
      console.log(this.packageDeatails);
      this.filterdPackage = [this.packageDeatails];
      this.subscriptionbillingUtility.selectedPackage = this.packageDeatails;
      localStorage.setItem('packageDetails', JSON.stringify(this.packageDeatails));
      this.subscriptionbillingUtility.packageValidityList = this.packageDeatails?.packageSubscriptionList.sort((a:any,b:any)=>a.numOfMonths - b.numOfMonths);
      this.subscriptionbillingUtility.selectedValidity = this.microCourses?this.subscriptionbillingUtility?.packageValidityList?.find(element=>element.numOfMonths == this.selectedMonths):this.subscriptionbillingUtility?.packageValidityList?.[0];
      this.subscriptionbillingUtility.packageValidityList?.forEach((val:any)=>{
      this.subscriptionbillingUtility.today=new Date();
          let vDate = new Date(this.subscriptionbillingUtility.today.setMonth(this.subscriptionbillingUtility.today.getMonth()+val.numOfMonths))
          val.validDate = new Date(vDate.setDate(vDate.getDate() - 1));
          val.amountpermonth=val.amount/val.numOfMonths;
        });
      let selectdMnth = this.subscriptionbillingUtility?.packageValidityList?.find(element=>element.numOfMonths == this.selectedMonths);
      console.log(selectdMnth);
      this.selectPackage(selectdMnth);
    });
  } else {
    var param = {
      examName: this.queryParams?.examName,
      year: this.queryParams?.year,
      producttype: 'assessment,liveclasses',
      grade: this.queryParams?.grade,
    }
    console.log(param);
    console.log(this.queryParams?.productName);
    let grade = this.queryParams.grade;
    this.selectedGrade = grade;
    localStorage.setItem('grade', this.queryParams.grade);
    this.SubscriptionService.getPackageDetails(param, grade).subscribe((result: any) => {
      if((this.queryParams?.grade == 6 || this.queryParams?.grade == 7) && this.queryParams?.productName === 'Ultimate Package'){
        this.packageDeatails = result.find(element=> element.name.includes(this.queryParams?.subject));
        console.log(this.packageDeatails);
        this.filterdPackage = [this.packageDeatails];
        this.subscriptionbillingUtility.selectedPackage = this.packageDeatails;
        localStorage.setItem('packageDetails', JSON.stringify(this.packageDeatails));
      } else {
        this.packageDeatails = result.find(element=> element.productName == this.queryParams?.productName);
        console.log(this.packageDeatails);
        this.filterdPackage = [this.packageDeatails];
        this.subscriptionbillingUtility.selectedPackage = this.packageDeatails;
        localStorage.setItem('packageDetails', JSON.stringify(this.packageDeatails));
      }
      
    });
  }
    
    this.syllabusFilter(this.queryParams?.courses, this.queryParams?.grade)
    this.enrollNowForm();
    this.getExams();
    this.getGrades();
    getIpAddress();
    this.sharedLink = window.location.href;
    this.encodedUrl = this.encode.encodeValue(this.sharedLink);
  }

  onOtpChange(event) {
    if (event.length === 4) {
      this.otp = event;
      this.otpValid = true;
    } else {
      this.otpValid = false;
    }
  }
  startCountdown(seconds) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
        this.resendotp = true;
        clearInterval(interval);
      }
    }, 1000);
  }

  stopCountdown(seconds) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
        window.location.reload();
        clearInterval(interval);
      }
    }, 1000);
  }

  get enroll() {
    return this.enrollnowForm.controls;
  }
  enrollNowForm() {
    this.enrollnowForm = this.fb.group({
      phone: ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email:['', [Validators.required,Validators.email]],
      state: ['', [Validators.required]],
      // pincode:['',[Validators.required,Validators.pattern('(^[0-9]{6}$)')]],
      whatsappConsent: [true, [Validators.required]],
    });
  }

  verifyPhone() {
    this.otpSent = true;
    this.resendotp = false;
    this.startCountdown(59);
    if (
      this.enrollnowForm?.value?.phone &&
      !this.enrollnowForm?.get('phone')?.errors
    ) {
      console.log(this.enrollnowForm.value.phone);

      let phone: any = { phone: Number(this.enrollnowForm.value.phone) };

      let logData = {
        dialCode: '+91',
        number: Number(this.enrollnowForm.value.phone),
      };
      this.singupService.verifyPhoneNumber(logData).subscribe((data) => {
        console.log(data.existingUser);
        this.isExitingUser = data?.existingUser;
        if (data.existingUser === true) {
          console.log('existinguser');

          this.gaService.webEngageEvent({
            event: 'Payment otp count',
            first_name: this.enrollnowForm.value.firstName,
            last_name: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
          })
          this.singupService.generateOtp(phone, '+91').subscribe((result) => {
            console.log(result);
          });
        } else {
          console.log('newuser');
          let data = {
            firstName: this.enrollnowForm.value.firstName,
            lastName: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
            whatsappConsent: this.enrollnowForm.value.whatsappConsent,
            isdCode: '+91',
            courses: this.queryParams.courses,
            gradeId: this.queryParams.grade,
            register: true,
          };
          this.singupService.generateOtp(data, '+91').subscribe((result) => {
            console.log(result);
          });
          this.gaService.webEngageEvent({
            event: 'Payment otp count',
            first_name: this.enrollnowForm.value.firstName,
            last_name: this.enrollnowForm.value.lastName,
            phone: this.enrollnowForm.value.phone,
          })
        }
      });
    }
  }

  verifyOtp() {
    // this.isOtpVerified = true;
    // this.otpError = true;
    let request = {
      isdCode: '+91',
      phone: this.enrollnowForm?.value?.phone,
      userOtp: this.otp,
    };
    let payload = {
      countryCode: request.isdCode,
      phone: request.phone,
      otp: request.userOtp,
      "userActivityTrackingDataDto": !this.sendTrackAPIOnSignInOrSignUp 
      ? undefined 
      : {
        "data": { 
          page: `Learning-Festival`,
          actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
          utm_url: document.referrer + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
          utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
          utm_term: this.queryParams?.utm_term,
          utm_source: this.queryParams?.utm_source,
          utm_medium: this.queryParams?.utm_medium,
          utm_campaign: this.queryParams?.utm_campaign,
          utm_content: this.queryParams?.utm_content, 
        },
        "landingPage": "Learning-Festival"
      },
    };
    this.singupService
      .validateOtp(payload)
      .subscribe(
        (data) => {
          console.log(data);
          if (data?.accessToken) {
            console.log(data?.accessToken)
            this.isOtpVerified = true;
            // this.userService.setCookie(
            //   'INFINITY_LEARN',
            //   JSON.stringify(data),
            //   1
            // );
          
          this.userId = data.userDto.userId;
          console.log(this.userId);
          this.userData = data;
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('studentId', data.userDto.phone);
          let userInfo: any = {
            firstName: data.userDto.firstName,
            grade: this.queryParams.gradeId,
            isdCode: data.userDto.isdCode,
            lastName: data.userDto.lastName,
            phone: data.userDto.phone,
            profilePhoto: data.userDto.profilePhoto,
            userId: data.userDto.userId,
            whatsappConsent: true,
          }
          localStorage.setItem('mobile_and_name', JSON.stringify(userInfo));
          localStorage.setItem('infinity_usertype', JSON.stringify(data.userDto.userType));
          localStorage.setItem('user_details_from_server', JSON.stringify(data.userDto))
          localStorage.setItem('targetExamName', this.queryParams.examName);
          let body = { ...data?.userDto,
            exams: [this.examName.find((ind) =>ind.name.replace(/[^a-z]/ig,'').toUpperCase() == this.packageDeatails?.examName)],
            grade: this.grades.find((ind) =>ind.name.toLowerCase() == this.queryParams?.grade+'th')    
          }
          console.log(body);
          this.userService.updateUserDetails(body).subscribe(res=>{
            console.log(res);
            this.updatedUser = res;
            this.sendSQS(res?.userDto);
          })
          if (this.navExtra?.register) {
            this.gaService.webEngageEvent({
              event: 'SignUp',
              phone: data.userDto.phone,
              whatsapp_consent: data.userDto.whatsappConsent,
              first_name: data.userDto.firstName,
              last_name: data.userDto.lastName,
              grade: data?.userDto?.grade?.name
                ?.replace('st', '')
                ?.replace('nd', '')
                ?.replace('rd', '')
                ?.replace('th', ''),
              exam_name: '',
              pick_a_date: '',
              target_year: null, // Data type should be number
              subject: '',
            });
          }
        } else{
          console.log('worng-otp')
          this.otpError = true;
        }
        },
        (error: any) => {
          console.log('worng otp');
          this.otpError = true;
          // this.stopCountdown(58);
          // window.location.reload();
          
        }
      );
  }

  BuyNow() {
    if(this.packageDeatails?.productId == 3){
      this.getBatchDetails();
    } else {
      this.subscriptionbillingUtility.packageValidityList = this.packageDeatails?.packageSubscriptionList.sort((a:any,b:any)=>a.numOfMonths - b.numOfMonths);
      this.subscriptionbillingUtility.selectedValidity = this.microCourses?this.subscriptionbillingUtility?.packageValidityList?.find(element=>element.numOfMonths == this.selectedMonths):this.subscriptionbillingUtility?.packageValidityList?.[0];
      this.subscriptionbillingUtility.packageValidityList?.forEach((val:any)=>{
      this.subscriptionbillingUtility.today=new Date();
          let vDate = new Date(this.subscriptionbillingUtility.today.setMonth(this.subscriptionbillingUtility.today.getMonth()+val.numOfMonths))
          val.validDate = new Date(vDate.setDate(vDate.getDate() - 1));
          val.amountpermonth=val.amount/val.numOfMonths;
        });
      $('#enrollnow').modal('show');
      console.log(this.subscriptionbillingUtility);
      this.gaService.webEngageEvent({
        event: 'Buy Package',
        package_name: this.subscriptionbillingUtility?.selectedPackage?.name,
        amount: this.subscriptionbillingUtility?.selectedValidity?.amount,
      });
    }
    let details = localStorage.getItem('packageDetails');
    let arr = { "selectedPackage": details };
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(arr));
    // console.log(details);
  }

  Submit(){
    $('#enrollnow').modal('hide');
    console.log(this.enrollnowForm.value);
    setLoggedInUserData(this.updatedUser, this.userService, this.authService);
    let _headers = {
      'accesstoken': this.userData.accessToken,
      'studentid': `${this.userData.phone}`,
      // 'methodtype': 'RULES'
    };
    this.saveAccessToken(_headers,)
    if(!this.sendTrackAPIOnSignInOrSignUp ) {
      isUserAdmin(this.userService).then((bool) => {
        if(!bool) {
          this.userService.callTrackingAPI(this.updatedUser.userDto.userId, 
            {
            data: 
            { page: `Learning-Festival`,
            actions: `${this.queryParams.courses} Grade ${this.queryParams.grade} ${this.queryParams.productName}`,
            utm_url: document.referrer + this.queryParams?.page + '&' + 'utm_Id=' + this.queryParams?.utm_id + '&' + 'utm_term=' + this.queryParams?.utm_term+ '&' + 'utm_source=' + this.queryParams?.utm_source+ '&' + 'utm_medium=' + this.queryParams?.utm_medium+ '&' + 'utm_campaign=' + this.queryParams?.utm_campaign+ '&' + 'utm_content=' +  this.queryParams?.utm_content+ '&'  + 'utm_campaingn_id=' + this.queryParams?.campaign_id,
            utm_id: this.queryParams?.utm_id || this.queryParams?.campaign_id,
            utm_term: this.queryParams?.utm_term,
            utm_source: this.queryParams?.utm_source,
            utm_medium: this.queryParams?.utm_medium,
            utm_campaign: this.queryParams?.utm_campaign,
            utm_content: this.queryParams?.utm_content, 
            }}).subscribe();
        }
      })
    }
  this.spinner.show();
  let selectedState = this.ilstates.find(ele=>ele.abbreviation == this.enrollnowForm?.value?.state);
  var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
    ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
    : {};
  userDetails.email = this.enrollnowForm?.value?.email;
  userDetails.state = Number(this.enrollnowForm?.value?.state);
  userDetails.pincode = selectedState?.pincode;
  userDetails.address = selectedState?.city;
  localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(userDetails));
  this.addInCartV2();
  this.spinner.hide();
  this.subscriptionbillingUtility.stateName =
  this.subscriptionbillingUtility.states.find(
    (val) =>
      val.abbreviation == this.enrollnowForm?.value?.state
  );
  if(this.queryParams?.microCourses ==='micro'){
    this.gaService.webEngageEvent({
      event: 'Micro-Courses-Registration-Successful',
      first_name: this.enrollnowForm?.value?.firstName,
      last_name: this.enrollnowForm?.value?.lastName,
      email: this.enrollnowForm?.value?.email,
      phone: this.enrollnowForm?.value?.phone,
      state: this.subscriptionbillingUtility?.stateName?.name,
      grade: this.queryParams?.grade,
      courseName: this.queryParams?.courses
    });
  } else {
    this.gaService.webEngageEvent({
      event: 'LF Checkout Start',
      first_name: this.enrollnowForm?.value?.firstName,
      last_name: this.enrollnowForm?.value?.lastName,
      email: this.enrollnowForm?.value?.email,
      phone: this.enrollnowForm?.value?.phone
    });
  }
  }

  saveAccessToken(_headers: any, navigateToDashboard?: any): any {
    let route = '/subscription/subscriptionPackages';
    let userType = this.userService.getUserType()
    if (userType == 2) {
      route += '/liveclass';
    }
    else {
      // if (environment?.portal == 'teacher') {
      //   this.loginService.logoutEvent.emit({ showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.` });
      //   return;
      // }
    }
  }

  editNum() {
    window.location.reload();
  }

  getPackageDetails(){
    return localStorage.getItem('packageDetails');
  }

  selectPackage(selecteddata: any) {
    this.selectedMonths = selecteddata?.numOfMonths;
    this.microMobAmount = selecteddata?.amount;
    this.subscriptionbillingUtility.selectedDuration = selecteddata;
    this.subscriptionbillingUtility.assesmentList = selecteddata?.componentsList;
  }

  openTermsAndConditionsDialog(): void {
    const config: MatDialogConfig = {
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(
      TermsAndConditionsDialogComponent,
      config
    );
  }

  openPrivacyPolicyDialog() {
    const config: MatDialogConfig = {
      // width: '557px',
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, config);
  }

  getGrades(){
    this.targetExamService.fetchGradesList().subscribe(res=>{
      console.log(res);
      this.grades =res;
    })
  }
  getExams(){
    this.targetExamService.fetchTargetExamList().subscribe(res=>{
     res.forEach(ele=>{
        console.log(ele.name.replace(/[^a-z]/ig,'').toUpperCase())
      })
      this.examName = res;
      console.log(this.examName)
    })
  }

  syllabusFilter(exam,grade){
    this.festivalSyllabus.forEach(res=>{
      if(res.exam == exam){
        this.filterData = res.data;
        console.log(this.filterData);
      }
    });
    this.filterData.forEach(ele=>{
      if(ele.grade == grade){
        this.gradeData = ele;
        console.log(this.gradeData);
        let sub = this.gradeData?.subjects?.[0];
        console.log(sub);
        this.subjectChanged(sub);
      }
    })
  }
  
  subjectChanged(sub: any) {
    console.log(sub);
    this.selectedSubject = sub;
  }

  getBatchDetails() {
    setTimeout(() => {
      this.SubscriptionService.fetchBatchDetails(
        this.packageDeatails?.packagesCourseDtoList?.[0]?.courseId
      ).subscribe((response: any) => {
        this.subscriptionbillingUtility.batchList = response?.data?.batches
          ?.filter((val) => val.canEnrollToBatch)
          ?.map((val) => {
            val.startDate = moment.unix(val.startDate).toDate();
            val.endDate = moment.unix(val.endDate).toDate();
            return val;
          });
        this.subscriptionbillingUtility.courseSelected = response?.data;
        this.courseSelected = response?.data;
        this.selectedBatch = response?.data?.batches?.[0];
        this.subscriptionbillingUtility.selectedBatch = response?.data?.batches?.[0];
        this.subscriptionbillingUtility.dateForDuedate = response?.data?.batches?.[0]?.startDate;
        console.log(response.data);
        console.log(this.subscriptionbillingUtility);
        var payments = localStorage.getItem(apisDataCacheKeys.payments)
        ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
        : {};
        payments.selectedBatch = response?.data?.batches?.[0];
        payments.selectedPackage= this.subscriptionbillingUtility?.selectedPackage;
        payments.courseSelected = response?.data;
        localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
        if(this.selectedBatch?.id){
          $('#enrollnow').modal('show');
        } else {
          let dialogRef = this.dialog.open(
            TestRegistrationConfirmDialogComponent,
            {
              height: '280px',
              width: '500px',
              data: {
                message1: 'Oops!',
                message2: 'No Batches Found',
              },
            }
          );
        }
      },(err) => {
        this.spinner.hide();
        if (err?.status == 400) {
          let dialogRef = this.dialog.open(
            TestRegistrationConfirmDialogComponent,
            {
              height: '280px',
              width: '500px',
              data: {
                message1: 'Oops!',
                message2: err?.error?.message,
              },
            }
          );
        }
      });
    }, 0);

    this.gaService.webEngageEvent({
      event: 'Buy Package',
      package_name: this.subscriptionbillingUtility?.selectedPackage?.name,
      amount: this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.amount,
    });
  }

  addInCart() {
    console.log(this.subscriptionbillingUtility.selectedPackage);
    var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
    ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
    : {};
    this.subscriptionbillingUtility.userDetails = userDetails;
    const userGrade = this.subscriptionbillingUtility?.userDetails?.grade?.name?.replace(/[^0-9]/g,'');
    let body={
      "addOn": false,
      "batchId": this.subscriptionbillingUtility?.selectedBatch?.id,
      "courseId":this.subscriptionbillingUtility?.courseSelected?.id,
      "created_by": this.subscriptionbillingUtility?.userDetails?.firstName+' '+this.subscriptionbillingUtility?.userDetails?.lastName,
      "created_date": moment().utc(),
      "grade": userGrade,
      "id": 0,
      "modified_by": this.subscriptionbillingUtility?.userDetails?.firstName+' '+this.subscriptionbillingUtility?.userDetails?.lastName,
      "modified_date": moment().utc(),
      "phoneNo": this.subscriptionbillingUtility.userDetails?.phone,
      "priority": 1,
      "quantity": 1,
      "scoreId": null,
      "status": true,
      "subscriptionId": this.subscriptionbillingUtility?.selectedBatch?.id
      ? this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.id
      : this.subscriptionbillingUtility?.selectedValidity?.id
      ? this.subscriptionbillingUtility?.selectedValidity?.id: '',
      "userId": this.subscriptionbillingUtility?.userDetails?.userId,
      "afterDiscountAmount": 0,
      "amountOrPercentage": this.subscriptionbillingUtility?.selectedValidity?.displayDiscountPercentage || this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.displayDiscountPercentage,
      "amount": Number(this.subscriptionbillingUtility?.selectedValidity?.amount || this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.amount),
      "code": null,
      "discountType": null,
    }
    let cartbody = {
      grade: userGrade,
      userId: this.subscriptionbillingUtility.userDetails?.userId
    }
    this.SubscriptionService.getAllCartItems(cartbody).subscribe((response: any) => {
      let checkSubscriptionExisted;
      if (this.packageDeatails?.productId == 7 && this.packageDeatails.type == 'edit') {
        checkSubscriptionExisted =  response?.find(v => v?.id == this.packageDeatails.scoreCartId );
      } else if([7].indexOf(this.packageDeatails?.productId ) ==-1){
        checkSubscriptionExisted =  response?.find(v => v?.subscription?.packages?.id == this.packageDeatails.id );
      }
      var findAlreadyexistedData = this.courseSelected?.id ? response.find(v => v.courseId == this.courseSelected?.id):undefined;
      if (this.packageDeatails?.productId != 1 && this.courseSelected?.id && this.selectedBatch?.id && !findAlreadyexistedData) {//for ultimate package if package id not present, then select id from the cart list while updating 
        findAlreadyexistedData = response.find(v => v.courseId && v.batchId);
      }
      if (this.packageDeatails?.productId != 1 && this.packageDeatails?.productId != 7 && this.courseSelected?.id && this.selectedBatch?.id && findAlreadyexistedData?.courseId) {//for ultimate package where we hae cousre id already selected 
          body.batchId = this.selectedBatch?.id;
          body.id = findAlreadyexistedData?.id;
      }
      else if((this.packageDeatails?.productId == 1 || this.packageDeatails?.productId == 7 || this.packageDeatails?.productId == 6 || this.packageDeatails?.productId == 9) && checkSubscriptionExisted){//for Advance  package where we hae package id or number of  months is already selected
        body.id = checkSubscriptionExisted?.id 
      }
      if(this.packageDeatails?.productId == 7 && this.packageDeatails.type == 'add' &&  this.SubscriptionService.scoreSelectionDetails?.editType == 'add'){
        body.id = 0
        this.saveCart(body)
        return;
      }
      if(checkSubscriptionExisted || findAlreadyexistedData){
        this.spinner.show();
        this.SubscriptionService.updateCart(body).subscribe((response:any) => {
          localStorage.setItem('CartItemID', response?.id);
          let dialogRef = this.dialog.open(FestivalPaymentComponent,
            {
              height: '650px',
              width: '1000px',
              panelClass:'festival-offer-dialog',
              data: {paymentData: this.subscriptionbillingUtility,},
            }
          );
          this.spinner.hide();
        }, err => {
          this.spinner.hide();
        })
      }
      else{
        this.saveCart(body)
      }
    })
  }

  addInCartV2() {
    console.log(this.subscriptionbillingUtility.selectedPackage);
    var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
    ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
    : {};
    this.subscriptionbillingUtility.userDetails = userDetails;
    const userGrade = this.subscriptionbillingUtility?.userDetails?.grade?.name?.replace(/[^0-9]/g,'');
    let body={
      "addOn": false,
      "batchId": this.subscriptionbillingUtility?.selectedBatch?.id,
      "courseId":this.subscriptionbillingUtility?.courseSelected?.id,
      "created_by": this.subscriptionbillingUtility?.userDetails?.firstName+' '+this.subscriptionbillingUtility?.userDetails?.lastName,
      "created_date": moment().utc(),
      "grade": userGrade,
      "id": 0,
      "modified_by": this.subscriptionbillingUtility?.userDetails?.firstName+' '+this.subscriptionbillingUtility?.userDetails?.lastName,
      "modified_date": moment().utc(),
      "phoneNo": this.subscriptionbillingUtility.userDetails?.phone,
      "priority": 1,
      "quantity": 1,
      "scoreId": null,
      "status": true,
      "subscriptionId": this.subscriptionbillingUtility?.selectedBatch?.id
      ? this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.id
      : this.subscriptionbillingUtility?.selectedValidity?.id
      ? this.subscriptionbillingUtility?.selectedValidity?.id: '',
      "userId": this.subscriptionbillingUtility?.userDetails?.userId,
      "afterDiscountAmount": 0,
      "amountOrPercentage": this.subscriptionbillingUtility?.selectedValidity?.displayDiscountPercentage || this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.displayDiscountPercentage,
      "amount": Number(this.subscriptionbillingUtility?.selectedValidity?.amount || this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.amount),
      "code": null,
      "discountType": null,
    }
    let cartbody = {
      grade: userGrade,
      userId: this.subscriptionbillingUtility.userDetails?.userId
    }
    this.SubscriptionService.getAllCartItems(cartbody).subscribe((response: any) => {
      if(response.length){
        var cartItemPromisearray =[]
    response.forEach((cartItem)=>{ 
      cartItemPromisearray.push(this.deleteCartItems(cartItem.id))
    })
    Promise.all(cartItemPromisearray).then((re)=>{
      console.log('delte item');
      this.saveCart(body);
    })
      }
      else{
        this.saveCart(body)
      }
    })
  }

saveCart(body){
  this.SubscriptionService.saveCart(body).subscribe((response:any)=>{
    this.spinner.show();
    localStorage.setItem('CartItemID', response?.id);
    let dialogRef = this.dialog.open(FestivalPaymentComponent,
      {
        height: '650px',
        width: '1000px',
        panelClass:'festival-offer-dialog',
        data: {paymentData: this.subscriptionbillingUtility,},
      }
    );
    this.spinner.hide();
  })
  }

  deleteCartItems(id){
    return new Promise((res,rej)=>{
      this.SubscriptionService.deleteFromCart(id).subscribe((resp)=>{
        res(true)
      })
    })
  }
  copycoupon(cpncd){
    this.linkCopid = true;
    this.copy="copied";
    setTimeout(() => { this.copy="" }, 2000);
    cpncd.select();
    document.execCommand('copy');
  }

  sendSQS(userData){
    this.firebaseService.getWebsiteSqsValue().then((firebaseRSP)=>{
      let fields = {
        SourceCampain : this.queryParams?.utm_campaign || undefined,
        SourceMedium : this.queryParams?.utm_medium || undefined,
        SourceContent : this.queryParams?.utm_content || undefined,
        mx_Custom_1: this.queryParams?.utm_url || undefined,
        mx_Custom_2: this.queryParams?.utm_source || undefined,
        mx_Custom_3: this.queryParams?.utm_campaign || undefined,
        mx_Custom_4: this.queryParams?.utm_medium || undefined,
        mx_Custom_5: this.queryParams?.utm_content || undefined,
        mx_Custom_6: this.queryParams?.utm_id || undefined,
        mx_Custom_7: this.queryParams?.utm_term || undefined,
        mx_Custom_8 :'Learning-Festival' || undefined,
        mx_Grade: Number(userData?.grade?.name?.replace(/[a-z]/ig,'')) || undefined,
        mx_Exam: userData?.exams?.[0]?.name?.replace(/[^a-z]/ig,'').toUpperCase() || undefined,
        mx_Primary_Target_Exam: userData?.exams?.[0]?.name?.replace(/[^a-z]/ig,'').toUpperCase() || undefined,
        mx_Actual_source_URL: window.location.href,        
      }
      let firebasePayload = {
        "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        "Fields": fields,
        "FirstName": userData?.firstName,
        "LastName": userData?.lastName,
        "environment": environment?.branch,
        "phone": userData?.phone,
        "Source": "IL Website",
        "productId": 1,
        "type": "Lead"
      }
      console.log(firebasePayload)
      this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload)
    })
  }

}
